import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboardIcon, ServerIcon, ShieldIcon, UsersIcon, MessageSquareTextIcon, CpuIcon, LogOutIcon, MessageCircleIcon } from 'lucide-react';
const navItems = [{
  path: '/',
  label: 'Dashboard',
  icon: <LayoutDashboardIcon size={20} data-id="element-289" />
}, {
  path: '/chat',
  label: 'Chat Console',
  icon: <MessageCircleIcon size={20} data-id="element-290" />
}, {
  path: '/models',
  label: 'Model Management',
  icon: <ServerIcon size={20} data-id="element-291" />
}, {
  path: '/guardrails',
  label: 'Guardrails',
  icon: <ShieldIcon size={20} data-id="element-292" />
}, {
  path: '/users',
  label: 'User Management',
  icon: <UsersIcon size={20} data-id="element-293" />
}, {
  path: '/prompts',
  label: 'Prompt Monitoring',
  icon: <MessageSquareTextIcon size={20} data-id="element-294" />
}, {
  path: '/gpu',
  label: 'GPU Overview',
  icon: <CpuIcon size={20} data-id="element-295" />
}];
const Layout = ({
  children,
  onLogout
}) => {
  return <div className="flex h-screen overflow-hidden" data-id="element-296">
      {/* Sidebar */}
      <div className="w-64 bg-gray-900 text-white flex flex-col" data-id="element-297">
        <div className="p-6 border-b border-gray-700" data-id="element-298">
          <h1 className="text-xl font-bold" data-id="element-299">MemBrain Platform</h1>
        </div>
        <nav className="flex-grow py-4" data-id="element-300">
          <ul className="space-y-1" data-id="element-301">
            {navItems.map(item => <li key={item.path} data-id="element-302">
                <NavLink to={item.path} className={({
              isActive
            }) => `flex items-center px-6 py-3 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors ${isActive ? 'bg-gray-800 text-white border-l-4 border-blue-500' : ''}`} data-id="element-303">
                  <span className="mr-3" data-id="element-304">{item.icon}</span>
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>
        <div className="p-4 border-t border-gray-700" data-id="element-305">
          <button onClick={onLogout} className="flex items-center text-gray-300 hover:text-white transition-colors" data-id="element-306">
            <LogOutIcon size={20} className="mr-3" data-id="element-307" />
            Logout
          </button>
        </div>
      </div>
      {/* Main content */}
      <div className="flex-1 overflow-auto bg-gray-50" data-id="element-308">
        <main className="p-6" data-id="element-309">{children}</main>
      </div>
    </div>;
};
export default Layout;